<template>
  <h-list-page class="SQMList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('cd451fe46150fb377a22905fc8f95ec0')" v-if="dataFrom == 'hmqm'">
          <h-autocomplete popper-class="planHidden" v-model="searchData.vendorCode" :fetch-suggestions="supplyCodeChange"
            :trigger-on-focus="false" @input="() =>
              searchData.vendorCode.length < 2 ? (showSupplyPlan = false) : ''" @clear="showSupplyPlan = false"
            clearable :placeholder="h_i18n('7bf2be6fb7b19250d25ce7f97564acbc')" @blur="detailBlur('showSupplyPlan')"
            @focus="detailFocus('showSupplyPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0">
            <el-table v-show="showSupplyPlan" v-loading="supplyLoading" :data="supplyCodeList" border size="small"
              max-height="252" @row-click="clickSupplierCode" @mousedown="planBlur = true">
              <el-table-column prop="supplyCode" :label="h_i18n('cd451fe46150fb377a22905fc8f95ec0')" width="120"></el-table-column>
              <el-table-column prop="supplyName" :label="h_i18n('aca38f22397ec3789f862612019ff66c')"></el-table-column>
            </el-table>
            <div v-if="showSupplyPlan && SupplyOver600" style="
                color: red;
                height: 20px;
                background-color: #fff;
                padding-top: 3px;
              ">
              <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('7c244ad1c726097ae714da60dff85888') }}</span>
            </div>
          </h-detail>
        </h-search>

        <h-search :title="h_i18n('aca38f22397ec3789f862612019ff66c')" v-if="dataFrom == 'hmqm'">
          <h-input v-model="searchData.vendorName" clearable @change="changeNull(searchData.vendorName, 'vendorName')">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <h-autocomplete popper-class="planHidden" v-model="searchData.mtlNo" :fetch-suggestions="mtlNoChange"
            :trigger-on-focus="false" @input="() =>
              searchData.mtlNo.length < 4 ? (showMtlPlan = false) : ''" @clear="showMtlPlan = false" clearable
            :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="detailBlur('showMtlPlan')" @focus="detailFocus('showMtlPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="showMtlPlan" v-loading="mtlLoading" :data="mtlNoList" border size="small" max-height="252"
              @row-click="clickMtlNo" @mousedown="planBlur = true">
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
            <div v-if="showMtlPlan && MtlOver600" style="color: red;height: 20px;background-color: #fff;
                padding-top: 3px;">
              <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('a1fc8066cb705fef975d7db6b39eaa79') }}</span>
            </div>
          </h-detail>
        </h-search>

        <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
          <h-input v-model="searchData.mtlName" clearable @change="changeNull(searchData.mtlName, 'mtlName')">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('13b062af2976411b3f19c9820febe842')">
          <h-input v-model="searchData.proBatchNo" clearable @change="changeNull(searchData.proBatchNo, 'proBatchNo')">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('cf6e0a2984af16dd0375af5137db5839')">
          <h-range-input v-model:min="searchData.percentMin" v-model:max="searchData.percentMax" clearable>
          </h-range-input>
        </h-search>

        <h-search :title="h_i18n('086709421d8a0ba2cfbc1c8148487b40')">
          <h-range-input v-model:min="searchData.offlinePercentMin" v-model:max="searchData.offlinePercentMax" clearable>
          </h-range-input>
        </h-search>

        <h-search :title="h_i18n('b44c0f337d2ffc27a09ff792a489b1e0')">
          <h-date-picker
            @change="TimeChange(searchData.inspectionDateStart, { start: 'inspectionDateStartTS', end: 'inspectionDateStartDD' })"
            v-model="searchData.inspectionDateStart" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')"
            :clearable="clearAble" />
        </h-search>

        <h-search :title="h_i18n('1d468be946f7be1133b3e2c682eee8c6')">
          <h-date-picker
            @change="TimeChange(searchData.inspectionDateEnd, { start: 'inspectionDateEndTS', end: 'inspectionDateEndDD' })"
            v-model="searchData.inspectionDateEnd" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')"
            :clearable="clearAble" />
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="this.loading" @click="handleCurrentChange(1)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('74b2e64aae927a7572c3f7bdcb3f084d')" :is-left="dataFrom == 'hmqm' ? 3 : 1" :is-right="0" :h-data="tableData">
      <template #buttonGroup>
        <h-button-group v-if="dataFrom == 'hmqm'">
          <template v-for="item in buttonList" :key="item.code">
            <h-button :loading="loadingEvent(item.code)" type="primary" @click="btnFunOfBtn(item.code)"
              :newEx="item.code == exportBtnCodeOfHac ? true : false">
              <template #icon>
                <i v-if="item.code == exportBtnCodeOfHac" class="iconfont icon-daochu"></i>
                <i v-if="item.code == mingxiBtnCodeOfHac" class="iconfont icon-xiangqing1"></i>
              </template>
              {{ item.name }}
            </h-button>
          </template>
          <div style="text-wrap:nowrap;color:#165dff;padding-left: 20px;">{{ h_i18n('d01ca7e3d16ef6d2ddfe543c150a8858') }}</div>
        </h-button-group>
        <h-button-group v-else>
          <template v-for="item in btnListOfSqm" :key="item.code">
            <template v-if="item.code == 'mkhl_gcjc_gczxjc_queryDetail'">
              <!-- 明细 -->
              <h-button type="primary" @click="Mingxi">
                <i class="iconfont icon-xiangqing1"></i>{{ h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a') }}</h-button>
            </template>
            <template v-if="item.code == 'mkhl_gcjc_gczxjc_export'">
              <!-- 导出 -->
              <h-button :loading="exportLoading" type="primary" @click="ExportSqm">
                <i class="iconfont icon-daochu"></i>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
            </template>
          </template>
          <!-- <h-button type="primary" @click="Mingxi">
              <i class="iconfont icon-xiangqing1"></i>
            明细
          </h-button>
          <h-button :loading="exportLoading" type="primary" @click="ExportSqm">
                <i class="iconfont icon-daochu"></i>
              导出
            </h-button> -->
            <div style="text-wrap:nowrap;color:#165dff;padding-left: 20px;">{{ h_i18n('d01ca7e3d16ef6d2ddfe543c150a8858') }}</div>
        </h-button-group>
     </template>
      <el-table :data="tableData" size="small" border height="540" style="width: 100%;min-height: 540px" @row-click="rowClick"
        :row-style="rowStyle" :row-class-name="rowClassName">
        <el-table-column v-if="dataFrom == 'hmqm'" prop="vendorCode" :label="h_i18n('cd451fe46150fb377a22905fc8f95ec0')" width="90"></el-table-column>
        <el-table-column v-if="dataFrom == 'hmqm'" prop="vendorName" :label="h_i18n('aca38f22397ec3789f862612019ff66c')" width="200">
          <template v-slot="scope">
            <div style="text-align:left">{{ scope.row.vendorName }}</div>
          </template>
        </el-table-column>
        <!-- 专用号 -->
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130">
          <template v-slot="scope">
            <div style="color:blue;cursor: pointer; text-align: left" @click="gotodetails(scope.row, scope.row.index)">{{
              scope.row.mtlNo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200">
          <template #default="scope">
            <div style="text-align:left">{{ scope.row.mtlName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="proBatchNo" :label="h_i18n('13b062af2976411b3f19c9820febe842')" width="160">
          <template v-slot="scope">
            <div style=" text-align: left">{{ scope.row.proBatchNo }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionDateStart" :label="h_i18n('29579acfab8de1dd2103c27f10aa58a6')" width="150" :formatter="dealDate"></el-table-column>
        <el-table-column prop="inspectionDateEnd" :label="h_i18n('cbb285e21363842af57e67db630b884b')" width="150" :formatter="dealDate"></el-table-column>
        <el-table-column prop="inspectionCount" :label="h_i18n('68bb4d5958284216a4191674afc15a43')" width=""></el-table-column>
        <el-table-column prop="qualified" :label="h_i18n('a15b31e1a456c94b4ccfae2ae3aec10d')" width="110"></el-table-column>
        <el-table-column prop="percent" :label="h_i18n('6771fc0fa5c82af8f3fa3ff7a97d3311')" width="110"></el-table-column>
        <el-table-column prop="offlineCount" :label="h_i18n('b560dae8ac39f7e5006ae29e22953f19')" width="110"></el-table-column>
        <el-table-column prop="offlinePercent" :label="h_i18n('ce0943223d1460af58e7c61331fbfb22')" width="110"></el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        v-model:currentPage="pagenation.pageNo" :page-size="pagenation.pageSize" layout="total, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
    </h-table-card>
  </h-list-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from 'moment'
import axios from "axios";
export default {
  name: 'SQMlist',
  data() {
    return {
      dom: {},
      dialogVisible: false,
      expents: false,
      value: "",
      pagenation: {
        pageSize: 10,
        pageNo: 1,
      },
      total: 0,
      inspectionDateStartTS: '',
      inspectionDateStartDD: '',
      inspectionDateEndTS: '',
      inspectionDateEndDD: '',
      timevalue: {
        inspectionDateStartTS: '',
        inspectionDateStartDD: '',
        inspectionDateEndTS: '',
        inspectionDateEndDD: '',
      },
      tableHead: [],
      tableData2: [],
      tableData: [],
      searchData: {
        mtlNo: '',
        vendorCode: '',
      },
      currentRow: '',
      loading: false,
      roleCode: "",
      chargeButList: [],
      keepalivestatus: 0,
      handleScroll: "",
      leavescrollTop: 0,
      setCurrentRow: 0,
      routerTo: false,
      mingxiBtnCodeOfHac: 'S01053_GCZXJC_MX',
      exportBtnCodeOfHac: 'S01053_GCZXJC_DC',
      mtlLoading: false,
      showMtlPlan: false,
      planBlur: false,
      MtlOver600: false,
      SupplyOver600: false,
      showSupplyPlan: false,
      mtlSearchHttp: false,
      supplySearchHttp: false,
      mtlNoList: [],
      supplyCodeList: [],
      buttonList: [],
      exportLoading: false,
      btnCodeList:[
      "mkhl_gcjc_gczxjc_export","mkhl_gcjc_gczxjc_queryDetail"
      ],
      btnListOfSqm:[]
    }
  },
  methods: {
    h_i18n,
    /**
* 传高度
*/
    changeMethod() {
      this.postThisPageHeight();
    },
    // 按钮公共处理函数
    // loading事件
    loadingEvent(code) {
      switch (code) {
        case this.exportBtnCodeOfHac:
          return this.exportLoading;
        default:
          return null;
      }
    },
    // btn事件
    btnFunOfBtn(code) {
      switch (code) {
        case this.exportBtnCodeOfHac:
          this.EXport();
          break;
        case this.mingxiBtnCodeOfHac:
          this.Mingxi()
          break

        default:
          return null;
      }
    },

    // input为空时undefined
    changeNull(value, key) {
      if (value === "") {
        this.searchData[key] = undefined;
      }
    },

    // 弹窗失焦
    detailBlur(v) {
      if (!this.planBlur) {
        this[v] = false;
      }
    },
    // 弹窗聚焦
    detailFocus(v) {
      this.planBlur = false;
      if (v == "showSupplyPlan") {
        if (this.searchData.vendorCode.length >= 2) {
          this[v] = true;
        }
      } else if (v == "showMtlPlan") {
        if (this.searchData.mtlNo.length >= 4) {
          this[v] = true;
        }
      }
    },
    clickMtlNo(row) {
      this.searchData.mtlNo = row.mtlNo;
      this.showMtlPlan = false;
    },
    clickSupplierCode(row) {
      this.searchData.vendorCode = row.supplyCode;
      this.showSupplyPlan = false;
    },
    /**
     * 专用号模糊查询
     */
    mtlNoChange() {
      this.planBlur = false;
      if (this.mtlSearchHttp) this.mtlSearchHttp.cancel();
      this.mtlSearchHttp = axios.CancelToken.source();
      if (this.searchData.mtlNo.length < 4) {
        this.showMtlPlan = false;
      } else {
        this.showMtlPlan = true;
        this.mtlLoading = true;
        this
          .$http({
            method: "POST",
            url: "/base/basicData/searchMaterielList",
            headers: { "content-type": "application/json" },
            data: {
              mtlNo: this.searchData.mtlNo,
            },
            cancelToken: this.mtlSearchHttp.token,
          })
          .then((res) => {
            this.mtlNoList = res.data.data;
            if (this.mtlNoList.length >= 600) {
              this.MtlOver600 = true;
              this.mtlLoading = false;
            } else {
              this.MtlOver600 = false;
              this.mtlLoading = false;
            }
          })
          .catch((e) => { });
      }
    },
    /**
     * 供应商模糊查询
     */
    supplyCodeChange() {
      this.planBlur = false;
      if (this.supplySearchHttp) this.supplySearchHttp.cancel();
      this.supplySearchHttp = axios.CancelToken.source();
      if (this.searchData.vendorCode.length < 2) {
        this.showSupplyPlan = false;
      } else {
        this.showSupplyPlan = true;
        this.supplyLoading = true;
        this
          .$http({
            method: "post",
            url: "/base/basicData/searchSupplierList",
            headers: { "content-type": "application/json" },
            data: {
              supplyCode: this.searchData.vendorCode,
            },
            cancelToken: this.supplySearchHttp.token,
          })
          .then((res) => {
            this.supplyCodeList = res.data.data;
            if (this.supplyCodeList.length >= 600) {
              this.SupplyOver600 = true;
              this.supplyLoading = false;
            } else {
              this.SupplyOver600 = false;
              this.supplyLoading = false;
            }
          })
          .catch((e) => { });
      }
    },
    // 两个模糊查询结束


    // 时间范围选择
    TimeChange(date, { start, end }) {
      if (date) {
        this.searchData[start] = this.time(date[0]);
        this.searchData[end] = this.time(date[1]);
      } else {
        this.searchData[start] = undefined;
        this.searchData[end] = undefined;
      }
    },


    // getNewproductList() {
    //     //ceshi
    //     this.$http({
    //         method: 'get',
    //         url: "/base/hpc/searchButton",
    //         // headers: { 'content-type': 'application/x-www-form-urlencoded' },
    //         params: {
    //             url: "/newproduct/model_list"
    //         },
    //     }).then((res) => {
    //         this.loading = false
    //         if (res.status == 200 && res.data.code == 1) {
    //             if (res.data.data) {
    //                 this.chargeButList = res.data.data.hacResourceDtoList || []

    //             }
    //         }
    //     })
    // },
    //默认显示一个月
    // chooseOnMonth(arr) {
    //     let date = new Date().getTime()
    //     let arr1 = arr.filter(v => {
    //         let newDate = new Date(v.testTime).getTime()
    //         return date - newDate <= 24 * 30 * 60 * 60
    //     })
    //     return arr1
    // },
    getChargeButList(name) {
      for (let i = 0; i < this.chargeButList.length; i++) {
        if (name == this.chargeButList[i].name) {
          return true
        }
      }
      return false
    },
    formatTen(num) {
      return num > 9 ? (num + "") : ("0" + num)
    },
    gotodetails(a) {
      this.routerTo = true
      // 获取需要绑定的table
      const selectWrap = document.querySelector('.el-table__body-wrapper')
      console.log(selectWrap.scrollTop, 'leavescrollTop')
      this.leavescrollTop = selectWrap.scrollTop
      this.setCurrentRow = a.rowIndex
      console.log(a, 'gotodetails')
      console.log(a.rowIndex, 'gotodetails')
      let roleType = true
      if ((this.roleCode == 'S009' || this.roleCode == 'S006') && this.dataFrom == 'sqm' || this.getChargeButList(h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95'))) {
        roleType = true;
      } else {
        roleType = false
      }
      this.$store.commit("setTop", document.querySelector(".el-table__body-wrapper").scrollTop)
      // console.log(document.querySelector(".el-table__body-wrapper").scrollTop, "跳转前触发=================================================")
      this.$router.push({
        path: "/Detailspage", query: {
          modelNo: a.vendorCode,
          prodBatch: a.proBatchNo,
          prodNo: a.mtlNo,
          roleType: roleType,
          dataFrom: this.dataFrom,
          name: window.getItemName,
          nickName: window.getItemNickName
        }
      })
    },
    formatDate(a) {
      let date = new Date(a)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return year + "-" + this.formatTen(month) + "-" + this.formatTen(day)
    },
    chosetime() {
      this.timevalue.inspectionDateStartTS = this.timevalue.inspectionDateStartTS == null || this.timevalue.inspectionDateStartTS == '' || this.timevalue.inspectionDateStartTS == undefined ? '' : this.time(this.timevalue.inspectionDateStartTS)
      this.timevalue.inspectionDateStartDD = this.timevalue.inspectionDateStartDD == null || this.timevalue.inspectionDateStartDD == '' || this.timevalue.inspectionDateStartDD == undefined ? '' : this.time(this.timevalue.inspectionDateStartDD)
      this.timevalue.inspectionDateEndTS = this.timevalue.inspectionDateEndTS == null || this.timevalue.inspectionDateEndTS == '' || this.timevalue.inspectionDateEndTS == undefined ? '' : this.time(this.timevalue.inspectionDateEndTS)
      this.timevalue.inspectionDateEndDD = this.timevalue.inspectionDateEndDD == null || this.timevalue.inspectionDateEndDD == '' || this.timevalue.inspectionDateEndDD == undefined ? '' : this.time(this.timevalue.inspectionDateEndDD)
    },
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', { //给每一行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },
    //实现选中高亮
    rowClassName({ row, column, rowIndex, columnIndex }) {
      if (this.currentRow == '' || this.currentRow == null || this.currentRow == undefined) {
        console.log('无数据')
      } else {
        if (row.rowIndex == this.currentRow.rowIndex) {
          return 'current-row';
        } else {
          return '';
        }
      }
      row.index = rowIndex;
    },
    rowClick(row, column, event) {
      // let refsElTable = this.$refs.filterTable; // 获取表格对象
      if (this.currentRow == null || this.currentRow === "") {
        this.currentRow = row;
        console.log('选中行', this.currentRow)
        return
      } else if (this.currentRow != '' && this.currentRow != null && this.currentRow != undefined) {
        if (this.currentRow.rowIndex == row.rowIndex && !this.routerTo) {
          // refsElTable.toggleRowSelection(row, false);
          this.currentRow = null;
          console.log('取消选中', this.currentRow)
          return
        } else {
          this.currentRow = row;
          console.log('选中新行', this.currentRow)
          return
        }
      }
    },
    handleCurrentChange(val) {
      this.pagenation.pageNo = val
      this.getReportLVist()
    },
    handleSizeChange(val) {
      console.log(val, '条数')
    },
    dealDate(row, column, cellValue, index) { // 处理时间格式
      // console.log("value",row[column.property],column.property)
      return row[column.property] ? moment(row[column.property]).format("YYYY-MM-DD  HH:mm:ss") : ""
    },
    // 查询表格数据
    getReportLVist() {
      let paramsvalue = {}
      if (this.dataFrom == 'hmqm') {
      } else {
        paramsvalue.vendorCode = this.supplyCode
      }
      this.loading = true;
      this.$http({
        method: 'post',
        url: '/base/onlineprocess/getProcessInspection',
        headers: { 'content-type': 'application/json' },
        data: {
          // name:'01505567',
          name: this.$route.query.name,
          ...this.timevalue,
          ...this.pagenation,
          ...this.searchData,
          ...paramsvalue,
          inspectionDateStart: undefined,
          inspectionDateEnd: undefined,
        },
      }).then((res) => {
        console.log(res, '查询到的数据')
        this.loading = false
        if (res.data.code == 200) {
          if (res.data.data.testProcessInspectionDTO) {
            this.tableData = res.data.data.testProcessInspectionDTO
            this.total = res.data.data.total
          } else {
            this.tableData = ''
            this.total = res.data.data.total
          }
        }
      });
    },
    //明细
    Mingxi() {
      this.$router.push(`/QueryDetails?dataFrom=${this.dataFrom === "hmqm" ? true : false}&name=${this.$route.query.name}&nickName=${this.$route.query.nickName}`)
    },
    EXport() {
      //导出方法
      // if (this.total > 10000) {
      //     this.$alert('导出数量大于10000条', '信息提示', {
      //         confirmButtonText: '确定',
      //         callback: action => {
      //         }
      //     })
      // } 
      if (this.total > 200000) {
        this.warning(
          {
            message: h_i18n('c54045d692bedb6365e073ce45b4e57e'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: (action) => { },
          }
        );
        return;
      }
      if (this.total < 1) {
        this.warning(
          {
            message: h_i18n('f59ec2b6c282f2c37663f524c2a318c3'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: (action) => { },
          }
        );
        return;
      }
      this.startLoading(h_i18n('4138f614307e0922e25f6f723e38098d'))
      this.exportLoading = true
      // 添加hmqm默认参数
      this.$http({
        method: 'post',
        url: '/base/onlineprocess/sqmExportProcessInspection',
        data: {
          name: this.$route.query.name,
          ...this.timevalue,
          ...this.searchData,
          inspectionDateStart: undefined,
          inspectionDateEnd: undefined,
        },
      }).then((res) => {
        this.info({
          message: res.data.msg || h_i18n('ad41f526b0670a747ed5827e062c1ad9'),
          title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
          confirmButtonText: h_i18n('937902e1941d0feb2cd108ed4aa79d21'),
          cancelButtonText: h_i18n('b15d91274e9fc68608c609999e0413fa'),
          callback: (action) => {
            if (action == 'confirm') {
              this.toDC()
            } else {

            }
            this.closeLoading();
            this.exportLoading = false
          },
        });
      }).catch((err) => {
        this.closeLoading();
        this.exportLoading = false
      });


    },
    ExportSqm() {
      if (this.total > 10000) {
        this.info(h_i18n('5e918af24d6756bed29794c63232a10e'), h_i18n('f148292ae0c683ca6fe4246350d309f6'), {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: action => {
          }
        })
      } else {
        let paramsvalue = {}
        paramsvalue.vendorCode = this.supplyCode
        this.startLoading(h_i18n('4138f614307e0922e25f6f723e38098d'))
        this.exportLoading = true
        this.$http({
          method: 'post',
          url: '/base/onlineprocess/sqmExportProcessInspection',
          data: {
            name: this.$route.query.name,
            ...this.timevalue,
            ...this.searchData,
            ...paramsvalue,
            inspectionDateStart: undefined,
            inspectionDateEnd: undefined,
          },
          responseType: "blob"
        }).then((res) => {
          if (res.status == 200) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }); // 文件流
            let blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a"); //模拟a链接，不支持低版本ie

            link.download = h_i18n('a52d69d5f522b19481d0abb41474877b');
            link.style.display = "none";
            link.href = blobUrl;
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          }
        }).catch((err) => {
          // Error: Request failed with status code 504
          console.info('导出失败', err);
          this.warning(h_i18n('CEB4728F29B8224B4B0D0F92BA3C54A4'))
        }).finally(() => {
          this.closeLoading();
          this.exportLoading = false
        })

      }
    },
    // handleTableHeight() {
    //     let vmEl = this.$refs.filterTable
    //     //计算滚动条的位置
    //     this.$nextTick(() => {
    //         this.$refs.filterTable.setCurrentRow(this.setCurrentRow)
    //     })
    //     console.log(this.leavescrollTop, 'handleTableHeight')
    //     console.log(this.setCurrentRow, 'setCurrentRow')
    //     // this.$refs.filterTable.scrollTop = this.leavescrollTop
    //     // this.formatDate()
    // },
    setTop() {
      setTimeout(() => {
        document.querySelector(".el-table__body-wrapper").scrollTop = this.$store.state.SQMlist.top
      })
    },
    main() {
      // this.timevalue.inspectionDateStartTS = this.formatDate(new Date().getTime() - 24 * 30 * 60 * 60 * 1000)
      // this.timevalue.inspectionDateStartDD = this.formatDate(new Date().getTime())
      // console.log(this.timevalue)
      this.searchData.inspectionDateStartTS = this.formatDate(new Date().getTime() - 24 * 30 * 60 * 60 * 1000)
      this.searchData.inspectionDateStartDD = this.formatDate(new Date().getTime())
      this.searchData.inspectionDateStart = [this.searchData.inspectionDateStartTS, this.searchData.inspectionDateStartDD]
    },
    getBtn() {
      this.searchButtonFromHacByCode(
        "/newproduct/Online_process_inspection",
        window.getItemName,
        window.getItemNickName
      ).then((v) => {
        this.buttonList = v;
      });
    },
  },
  created() {
    if (this.$route.query.dataFrom) {
      this.dataFrom = this.$route.query.dataFrom
    }
  },
  mounted() {
    if (this.$route.query.roleCode) {
      this.roleCode = this.$route.query.roleCode
    }
    if (this.$route.query.supplyCode) {
      this.supplyCode = this.$route.query.supplyCode
    }
    if (this.$route.query.dataFrom) {
      this.dataFrom = this.$route.query.dataFrom
    }
    if (this.$route.query.name || this.$route.query.nickName) {
      window.getItemName = this.$route.query.name
      window.getItemNickName = this.$route.query.nickName
      // this.dataFrom == 'hmqm' && this.getBtn()
    }
if(this.$route.query.parentId && this.$route.query.parentId != 'null' && this.$route.query.parentId != 'undefined' && this.$route.query.parentId != ''){
              let p = this.getButtonFromSqm(this.$route.query.parentId,this.$route.query.roleCode)
              p.then(res=>{
                if(res.length > 0){
                  this.btnListOfSqm = res
                }
              })
            }else{
              this.btnListOfSqm = [{code:"mkhl_gcjc_gczxjc_export",name:h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95')},{code:"mkhl_gcjc_gczxjc_queryDetail",name:h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a')}]
            }
    this.main()
    this.getReportLVist();
  },
  activated() {
    this.main()

    console.log('keepalive-activated页面打开时触发');
    if (this.keepalivestatus == 0) {
      console.log('首次打开')
    } else {
      this.setTop()
    }
  },
  deactivated() {
    this.keepalivestatus = this.keepalivestatus + 1
    console.log('keepalive-deactivated页面关闭时触发');
  },
}
if (window.location.search) {
  let search = window.location.search
  window.location.replace("/#/SQMlist" + search)
}
</script>

<style src="@/index.scss" lang="scss"></style>

<style lang="scss">
.planHidden {
  display: none;
}

.reportTemplateList {
  width: 1150px;
  margin: 0px auto;
  height: auto;
  overflow: visible;
  background: white;
  font-size: 12px;
  padding: 10px;

  .search {
    .searchLable {
      width: 30%;
    }

    .searchContent {
      width: 70%;
    }
  }

  .disableBut {
    color: gray !important;
    cursor: default !important;
  }

  .lable-left {
    margin-top: 0px;
    padding-right: 20px;
    border-bottom: 1px solid #E5E6E7;

    span {
      font-size: 1.5em;
      line-height: 33px;
      color: #333;
    }

    i {
      color: #387CD7;
      padding-right: 10px;
    }
  }
}
</style>